var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88867 0.324219L5.53711 3.68164L8.91211 2.72363L9.17578 4.5957L6.02051 4.87695L8.06836 7.61035L6.36328 8.5332L4.87793 5.58887L3.55078 8.52441L1.77539 7.61035L3.80566 4.87695L0.667969 4.58691L0.966797 2.72363L4.28027 3.68164L3.92871 0.324219H5.88867Z",
    fill: "#799AA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.751a247087f3bb6994e532e070458f04.svg";
export { ForwardRef as ReactComponent };